import GlobalFields from 'defs/ga/fields/global';
import { Overview, Preview, Start } from 'defs/ga/fields/programs';

export const trackProgramOverviewRecommended = ({ url, title }: { url: string; title: string }): Object => ({
	[GlobalFields.Event]: 'virtualPageView',
	[Overview.URL]: url,
	[Overview.Title]: title,
});

export const trackProgramOverviewMore = ({ url, title }: { url: string; title: string }): Object => ({
	[GlobalFields.Event]: 'virtualPageView',
	[Overview.URL]: url,
	[Overview.Title]: title,
});

export const trackProgramPreview = ({ url, title, programId }: { url: string; title: string; programId: string }) => ({
	[GlobalFields.Event]: 'virtualPageView',
	[Preview.URL]: url,
	[Preview.Title]: title,
	[Preview.ProgramId]: programId,
});

export const trackProgramStart = ({ programId }: { programId: string }) => ({
	[GlobalFields.Event]: 'buttonClick',
	[Start.ButtonText]: 'programm starten',
	[Start.ProgramId]: programId,
});

export const trackProgramReplace = ({ programId }: { programName?: string; programId: string }) => ({
	[GlobalFields.Event]: 'buttonClick',
	[Start.ButtonText]: 'programm ersetzen',
	[Start.ProgramId]: programId,
});

export const trackProgram = ({
	programName,
	action,
	programStart,
	programDuration,
	language,
	levelStatus,
	levelPoints,
}: {
	programName?: string;
	action: string;
	programStart: string;
	programDuration: string;
	language: string;
	levelStatus: string;
	levelPoints: string;
}) => ({
	[GlobalFields.Event]: 'coach_programm',
	[Start.Action]: action,
	[Start.ProgramName]: programName,
	[Start.ProgramStart]: programStart,
	[Start.ProgramDuration]: programDuration,
	[Start.Language]: language,
	[Start.LevelStatus]: levelStatus,
	[Start.LevelPoints]: levelPoints,
});
